import { type FieldValues, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, HfInput } from '@myosh/odin-components';
import { checkIdp } from '../helpers/check-idp';
import * as yup from 'yup';
import Footer from './footer.component';
import Sidebar from './sidebar.component';

export interface LoginFormProps {
  setIdp: (domain: string) => void;
}

const schema = yup.object().shape({
  email: yup.string().required('Email is a required field').email(),
});

export default function LoginForm({ setIdp }: LoginFormProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FieldValues>({
    resolver: yupResolver(schema) as never,
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  const loginButtonStyles = 'myl-m-0 myl-mt-6';

  const onSubmit = async (data: FieldValues) => {
    if (data.email !== '') {
      const idp = await checkIdp(data.email);
      return setIdp(idp);
    }
  };

  return (
    <div className="myl-login-layout myl-flex myl-min-h-screen myl-w-full myl-flex-col sm:myl-flex-row">
      <Sidebar />
      <div className="myl-login-main myl-flex myl-w-full myl-flex-1 myl-flex-col myl-bg-mono-1">
        <div className="myl-flex myl-max-w-sm myl-flex-1 myl-flex-col myl-justify-center myl-px-8 myl-pb-12 md:myl-ml-24 md:myl-px-0">
          <h2 className="myl-mb-6 myl-mt-8 myl-text-6xl myl-font-bold sm:myl-mt-12">Welcome</h2>
          <p className="md:myl-text-xl2 myl-mb-4 sm:myl-text-xl">Log in to myosh</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="myl-h-[50px]">
              <HfInput
                name="email"
                type="email"
                placeholder="Enter email"
                control={control}
                error={errors.email?.message as string | undefined}
                enableDebounce={false}
              />
            </div>
            <div className="myl-flex myl-flex-row">
              <Button type="primary" htmlType="submit" classNames={loginButtonStyles}>
                Log In
              </Button>
            </div>
          </form>
        </div>
        <Footer />
      </div>
    </div>
  );
}
